import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import AsyncLock from 'async-lock';
import { Entry } from "../models/entry";

@Injectable()
export class BookmarkService {

    private lock = new AsyncLock();
    private storageKey: string = 'bookmarks';

    constructor(
        private storage: Storage,
    ) {

    }

    public async getIds(): Promise<number[]> {
        let ids: number[] = await this.storage.get(this.storageKey + ':_ids');
        if (!ids) return [];
        return ids;
    }

    public async getAll(): Promise<Entry[]> {
        let ids = await this.getIds();
        let entries: Entry[] = [];

        for (let id of ids) {
            let entry = await this.storage.get(this.storageKey + ':' + id);
            entries.push(Entry.createOne(entry));
        }

        return entries;
    }

    protected async storeId(id: number): Promise<void> {
        let ids = await this.getIds();
        if (ids.indexOf(id) > -1) return;

        ids.push(id);
        await this.storage.set(this.storageKey + ':_ids', ids);
    }

    protected async storeEntry(entry: Entry): Promise<void> {
        await this.storage.set(this.storageKey + ':' + entry.id, entry);
    }

    public add(id: number): Promise<void>;
    public add(entry: Entry): Promise<void>;
    public add(item: number | Entry): Promise<void> {
        return this.lock.acquire<void>(this.storageKey, async () => {
            let id = item instanceof Entry ? item.id : item;
            await this.storeId(id);
            if (item instanceof Entry) await this.storeEntry(item);
        });
    }

    public remove(id: number): Promise<void>;
    public remove(entry: Entry): Promise<void>;
    public remove(item: number | Entry): Promise<void> {
        return this.lock.acquire<void>(this.storageKey, async () => {
            let id = item instanceof Entry ? item.id : item;

            let ids = (await this.getIds()).filter(value => value != id);

            await this.storage.set(this.storageKey + ':_ids', ids);
            await this.storage.remove(this.storageKey + ':' + id);
        });
    }

    public async has(id: number): Promise<boolean> {
        let ids: number[] = await this.getIds();
        return ids.indexOf(id) > -1;
    }

}



// WEBPACK FOOTER //
// ./src/providers/bookmark-service.ts